import { Tooltip } from '@mui/material';
import { FaDropbox } from 'react-icons/fa';
import AppConfig from '../../AppConfig';
import useDropboxChooserButton from '../../hooks/useDropboxChooserButton';

const buttonBaseClasses =
  'inline-flex items-center justify-center bg-white border border-border ' +
  'rounded-md p-1.5 text-primary leading-none ' +
  'hover:bg-surface-light disabled:hover:bg-white';

const buttonDisabledClasses = 'cursor-not-allowed opacity-50 z-[250]';

const DropboxChooserButton = ({
  acceptedFileTypes,
  multiselect = true,
  isDisabled = false,
  className = '',
  tooltip = 'Choose from Dropbox',
  onSuccess
}) => {
  const isDropboxEnabled = Boolean(AppConfig.DropboxAppKey);
  const { openChooser, isReady, isSupported } = useDropboxChooserButton({
    appKey: AppConfig.DropboxAppKey,
    isEnabled: isDropboxEnabled,
    acceptedFileTypes,
    multiselect,
    onSuccess
  });

  if (!isDropboxEnabled) return null;
  const isButtonDisabled = isDisabled || !isReady || !isSupported;

  return (
    <Tooltip title={tooltip} arrow placement="top">
      <span className={className}>
        <button
          type="button"
          className={`${buttonBaseClasses} ${isButtonDisabled ? buttonDisabledClasses : ''}`}
          onClick={openChooser}
          disabled={isButtonDisabled}
          aria-label={tooltip}
        >
          <FaDropbox size={18} />
        </button>
      </span>
    </Tooltip>
  );
};

export default DropboxChooserButton;
